import { render, staticRenderFns } from "./SquarePersonal.vue?vue&type=template&id=730e9bdf"
import script from "./SquarePersonal.vue?vue&type=script&lang=js"
export * from "./SquarePersonal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports